import { useState, MouseEvent } from 'react';

import config from 'config';

import { NavBarList } from './components';
import { useGetDataNavBar, useHandleTrackClick } from './hooks';
import { useResize } from '../../hooks';

import type { MenuItens } from 'core';

const HeaderNavBarWidget = () => {
  const { handleTrackClick } = useHandleTrackClick();
  const { getDataNavBar } = useGetDataNavBar();
  const [isMobile] = useResize();
  const data: MenuItens['links'] = getDataNavBar(config?.navBar, isMobile);

  const INITIAL_STATE = -1;
  const [currentIdx, setCurrentIdx] = useState(INITIAL_STATE);

  const handleOnClick = (event: MouseEvent<HTMLElement> | UIEvent, idx: number) => {
    if (currentIdx === idx) {
      setCurrentIdx(INITIAL_STATE);
      return;
    }
    setCurrentIdx(idx);
    handleTrackClick(event);
  };

  return (
    <>
      {data?.map((menu, index) => {
        return (
          <NavBarList
            key={menu?.iconeName?.toLocaleLowerCase()}
            menu={menu}
            isOpen={index === currentIdx}
            onClick={(event: MouseEvent<HTMLElement> | UIEvent) => handleOnClick(event, index)}
            isMobile={isMobile}
          />
        );
      })}
    </>
  );
};

export default HeaderNavBarWidget;
